export type EntryWindowState = "not_started" | "open" | "closed" | "no_window";

export function isEntryWindowOpen(
  entryStartsAt: Date | string | null | undefined,
  entryEndsAt: Date | string | null | undefined,
  now = new Date()
): boolean {
  const start = entryStartsAt ? new Date(entryStartsAt as string).getTime() : null;
  const end = entryEndsAt ? new Date(entryEndsAt as string).getTime() : null;
  const t = now.getTime();
  if (start !== null && !Number.isNaN(start) && t < start) return false;
  if (end !== null && !Number.isNaN(end) && t > end) return false;
  return true;
}

export function getEntryWindowState(
  entryStartsAt: Date | string | null | undefined,
  entryEndsAt: Date | string | null | undefined,
  now = new Date()
): EntryWindowState {
  const start = entryStartsAt ? new Date(entryStartsAt as string).getTime() : null;
  const end = entryEndsAt ? new Date(entryEndsAt as string).getTime() : null;
  const t = now.getTime();
  if (start !== null && !Number.isNaN(start) && t < start) return "not_started";
  if (end !== null && !Number.isNaN(end) && t > end) return "closed";
  if (start === null && end === null) return "no_window";
  return "open";
}
